"use client";
import { AppProgressBar } from "next-nprogress-bar";

export default function ProgressBar() {
  return (
    <AppProgressBar
      height="3px"
      color="#E63946"
      options={{ showSpinner: false }}
      shallowRouting
    />
  );
}
